import { Handle, Track } from './Toggle.style';

export const Toggle = ({ active, size }) => {
  return (
    <Track active={active} size={size}>
      <Handle active={active} size={size} />
    </Track>
  );
};
